// CalendarSkeleton — mirrors the loaded calendar's silhouette (top bar,
// day strip, gutter + staff columns) so the page doesn't jump on load.
import React from "react";
import "./calendarSkeleton.css";

const CalendarSkeleton = () => {
	return (
		<div className="sf-cal-shell sf-calendar-skeleton">
			{/* Top bar */}
			<div className="sf-skel-topbar">
				<div className="sf-skel-pill shimmer" />
				<div className="sf-skel-title shimmer" />
				<div className="sf-skel-pill shimmer" />
			</div>

			{/* Day strip */}
			<div className="sf-skel-day-strip">
				{Array.from({ length: 7 }).map((_, i) => (
					<div key={i} className="sf-skel-day-dot">
						<span className="sf-skel-dow shimmer" />
						<span className="sf-skel-date shimmer" />
					</div>
				))}
			</div>

			{/* Calendar grid */}
			<div className="sf-skel-grid">
				{/* Hour gutter */}
				<div className="sf-skel-hours">
					<div className="sf-skel-corner" />
					{Array.from({ length: 6 }).map((_, i) => (
						<div key={i} className="sf-skel-hour-cell">
							<span className="sf-skel-hour shimmer" />
						</div>
					))}
				</div>

				{/* Staff columns */}
				<div className="sf-skel-staff-columns">
					{Array.from({ length: 3 }).map((_, c) => (
						<div key={c} className="sf-skel-staff-col">
							{/* Column header */}
							<div className="sf-skel-staff-header">
								<span className="sf-skel-avatar shimmer" />
								<span className="sf-skel-name shimmer" />
							</div>

							{/* Hour rows */}
							<div className="sf-skel-hour-grid">
								{Array.from({ length: 6 }).map((_, r) => (
									<div key={r} className="sf-skel-hour-block" />
								))}

								{c === 0 && <div className="sf-skel-event shimmer" style={{ top: 40, height: 96 }} />}

								{c === 1 && (
									<>
										<div className="sf-skel-event shimmer" style={{ top: 12, height: 46 }} />
										<div className="sf-skel-event shimmer" style={{ top: 190, height: 130 }} />
									</>
								)}

								{c === 2 && <div className="sf-skel-event shimmer" style={{ top: 120, height: 110 }} />}
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default CalendarSkeleton;
